import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { SingleStoryHomepageLedeProps } from "../homepage-lede/SingleStoryHomepageLede";
import defaultIntegrityCheck from "../homepage-lede/SingleStoryHomepageLede.integrity";

export default function integrityCheck(
    props: SingleStoryHomepageLedeProps
): IntegrityStatus {
    return defaultIntegrityCheck(props);
}
